module.exports = __webpack_public_path__ + "img/max-file-approve--xml.168dcaf5.svg";